import dayjs from "dayjs";

export function formatArticleDate(date: string) {
  return dayjs(date).format("MMM DD, YYYY");
}

export function formatArticleTeaserDate(date: string) {
  return dayjs(date).format("MMM. YYYY");
}

/**
 * Case study post date as shown on listing cards, e.g. "14 September 2024".
 * The offset is dropped so the day renders as authored in the CMS and cannot
 * shift between the server and the browser.
 */
export function formatCaseStudyDate(date: string) {
  return dayjs(date.replace(/([+-]\d{2}:\d{2}|Z)$/, "")).format("D MMMM YYYY");
}

export function formatEventDate(date: string, format: string = "D MMM YYYY") {
  // Remove timezone offset to avoid timezone conversion during formatting
  // as we want to display the time as it was set in the CMS
  const [actualDate, _timezoneOffset] = splitDateAndTimezoneOffset(date);
  return dayjs(actualDate).format(format);
}

export function formatEventTime(date: string, timezoneLabel?: string) {
  const [actualDate, timezoneOffset] = splitDateAndTimezoneOffset(date);

  // Use timezone label if available, otherwise use GMT offset
  const label = timezoneLabel ? timezoneLabel : timezoneOffset ? `GMT${timezoneOffset}` : "";

  return dayjs(actualDate).format(`HH:mm [${label}]`);
}

export function getDaysDifferenceFromCurrent(date: string) {
  return dayjs(date).diff(dayjs(), "days");
}

/**
 * Split actual date and timezone offset from an ISO date string
 * @param date ISO date string with timezone offset
 * @returns An array with the actual date and the timezone offset
 */
const splitDateAndTimezoneOffset = (date: string) => {
  const match = date.match(/(.+)([+-]\d{2}:\d{2})$/);
  if (!match) return date;

  return [match[1], match[2]];
};
